import React, { useEffect, useState } from "react";
import "../../../styles/careers/subheader.scss";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { customPreHeader } from "../../../config/clients/clients";
import PropTypes from "prop-types";
import useClientConfig from "../../../config/careers/clientConfig";
 

type TypingEffectProps = {
  text: string;
  speed?: number;
  delay?: number; // Delay before starting backspace effect
  backspaceSpeed?: number; // Speed of backspace effect in milliseconds
};

const TypingEffect: React.FC<TypingEffectProps> = ({ text, speed = 100, delay = 1000, backspaceSpeed = 50 }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [isTyping, setIsTyping] = useState(true);
 
  useEffect(() => {
    let index = 0;
    let intervalId: NodeJS.Timeout;

    if (isTyping) {
      // Typing effect
      intervalId = setInterval(() => {
        setDisplayedText((prev) => text.slice(0, index + 1));
        index += 1;
        if (index === text.length) {
          clearInterval(intervalId);
          setTimeout(() => setIsTyping(false), delay); // Start backspace after delay
        }
      }, speed);
    } else {

      // Reset text after delay
      setTimeout(() => {
        setDisplayedText("");
        setIsTyping(true);
      }, 2200);

      // Backspace effect
      intervalId = setInterval(() => {
        setDisplayedText((prev) => prev.slice(0, -1));
        if (displayedText.length === 0) {
          clearInterval(intervalId);
          setIsTyping(true); // Restart typing after backspace
          setDisplayedText("");
        }
      }, backspaceSpeed);

      
    }

    return () => clearInterval(intervalId);
  }, [text, speed, delay, backspaceSpeed, isTyping]);

  return <div>{displayedText}</div>;
};


const PreHeader = () => {
    const cliendId = useParams();
    const location = useLocation();
    const clientConfig = useSelector((state: any) => state.careers.cliendConfig);
    const {clientSiteSettings} = useClientConfig();

 
    const [showPreHeader, setShowPreHeader] = useState(false);

    useEffect(() => {      

        if(clientSiteSettings?.showPreHeader){
            setShowPreHeader(true);
        }
    }, [clientConfig]);
    return (
        <>
        {showPreHeader ? (
            <div className="pre_header">
            <div className="pre_header_text">
                  {/* <TypingEffect text="Protect your operator's health" speed={100} delay={10000} backspaceSpeed={50}/>  */}
                  Saving Lives, Protecting Equipment &nbsp;| RS20 | ISO 23875 | MHSA
              </div>
              <div className="pre_header_button">
                  <a href="https://www.breathe-safe.com.au/get-a-quote/" target="_blank" rel="noopener noreferrer" className="btn btn-primary get_quote_btn">GET A QUOTE</a>
              </div>
            </div>
        ) : "" }
        </>
    );
};
export default PreHeader;